import store from '@/store'
import router from '@/router'
import routeNames from '@/router/routes'
import jwt from 'jsonwebtoken'
import moment from 'moment'
import { Http } from 'vue-resource'
import { generateUUID } from '@/lib/helpers/UUID'

export class RequestService {
  pendingPromises = {}
  authHeader () {
    return new Promise((resolve, reject) => {
      if (store.getters['auth/authToken']) {
        const tokenInfo = jwt.decode(store.getters['auth/authToken'])
        const tokenExp = tokenInfo.exp * 1000
        if (moment(tokenExp).isBefore(moment())) {
          localStorage.setItem('previousToken', store.getters['auth/authToken'])
          store.dispatch('auth/signOut').catch(() => {})
          router.push({ name: routeNames.login.name })
          reject(new Error('Tokens expired'))
        } else {
          resolve(store.getters['auth/authToken'])
        }
      } else {
        store.dispatch('auth/signOut').catch(() => {})
        reject(new Error('No tokens'))
      }
    })
  }
  setPromise (route, method, body, params, promise, headers) {
    this.pendingPromises[route] = {
      promise,
      body,
      method,
      params,
      route,
      headers: JSON.stringify(headers),
    }
  }
  getPromise (route, method, body, params, headers) {
    const saved = this.pendingPromises[route]
    if (saved && typeof saved !== 'undefined' && saved.body === body && saved.method === method && saved.params === params && saved.headers === JSON.stringify(headers)) {
      return saved.promise
    } else {
      return null
    }
  }
  removePromise (route, method, body, params, headers) {
    const saved = this.pendingPromises[route]
    if (saved && saved.body === body && saved.method === method && saved.params === params && saved.headers === JSON.stringify(headers)) {
      this.pendingPromises[route] = null
    }
  }
  async makePromise (route, method, { body, params, noAuth, responseType, multipart, disableStatusHandling, additionalHeaders }, mappingFunction) {
    let token
    let headers = {}

    if (!localStorage.getItem('anonymousUserId')) {
      localStorage.setItem('anonymousUserId', generateUUID())
    }
    headers['x-anonymous-user-id'] = localStorage.getItem('anonymousUserId')

    if (!noAuth) {
      token = await this.authHeader().catch((error) => {
        return new Promise((resolve, reject) => {
          reject(error)
        })
      })
      headers['x-api-key'] = token
    }

    if (multipart) {
      headers['Content-Type'] = 'multipart/form-data; boundary=something'
    }
    Object.assign(headers, headers, additionalHeaders)

    const currentPromise = this.getPromise(route, method, body, params, headers)
    if (currentPromise) {
      return currentPromise
    }
    const promise = new Promise(async (resolve, reject) => {
      if (noAuth || (!noAuth && token)) {
        if (method === 'get' || method === 'delete') {
          Http[method](route, {
            headers: headers || {},
            params: params || null,
            responseType: responseType || null,
            disableStatusHandling,
          }).then(
            data => {
              resolve(mappingFunction(data.body, data.headers))
            },
            error => {
              reject(error)
            }
          ).finally(() => {
            this.removePromise(route, method, body, params, headers)
          })
        } else {
          Http[method](route, body, {
            headers: headers || {},
            params: params || null,
            disableStatusHandling,
          }).then(
            data => {
              resolve(mappingFunction(data.body, data.headers))
            },
            error => {
              reject(error)
            }
          ).finally(() => {
            this.removePromise(route, method, body, params, headers)
          })
        }
      }
    })
    this.setPromise(route, method, body, params, promise, headers)
    return promise
  }
}
